import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSpotlightFooterInflatorContainer]',
  standalone: false
})
export class SpotlightFooterInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
